// extracted by mini-css-extract-plugin
export default {"fontImportant":"text_fontImportant__bK7XW"};